import axios from "axios";
export default {
    getProject: (projectId) => axios.post("/Projects/GetProjectDetailed", { Id: projectId }),
    getProjectSummaryReports: (projectId) => axios.post("/SummaryReports/GetProjectSummaryReports", { projectId })
};
